import _asyncToGenerator from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/regenerator/index.js";
import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { captureException } from '@sentry/core';
import { logger } from '@sentry/utils';
import workerString from './worker/worker.js';
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

function createEventBuffer(_ref) {
  var useCompression = _ref.useCompression;

  // eslint-disable-next-line no-restricted-globals
  if (useCompression && window.Worker) {
    var workerBlob = new Blob([workerString]);
    var workerUrl = URL.createObjectURL(workerBlob);

    try {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Using compression worker');
      var worker = new Worker(workerUrl);

      if (worker) {
        return new EventBufferCompressionWorker(worker);
      } else {
        captureException(new Error('Unable to create compression worker'));
      }
    } catch (e) {// catch and ignore, fallback to simple event buffer
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Falling back to simple event buffer');
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Using simple buffer');
  return new EventBufferArray();
}

var EventBufferArray = /*#__PURE__*/function () {
  function EventBufferArray() {
    _classCallCheck(this, EventBufferArray);

    this._events = [];
  }

  _createClass(EventBufferArray, [{
    key: "destroy",
    value: function destroy() {
      this._events = [];
    }
  }, {
    key: "length",
    get: function get() {
      return this._events.length;
    }
  }, {
    key: "addEvent",
    value: function addEvent(event, isCheckout) {
      if (isCheckout) {
        this._events = [event];
        return;
      }

      this._events.push(event);
    }
  }, {
    key: "finish",
    value: function finish() {
      var _this = this;

      return new Promise(function (resolve) {
        // Make a copy of the events array reference and immediately clear the
        // events member so that we do not lose new events while uploading
        // attachment.
        var eventsRet = _this._events;
        _this._events = [];
        resolve(JSON.stringify(eventsRet));
      });
    }
  }]);

  return EventBufferArray;
}(); // exporting for testing


var EventBufferCompressionWorker = /*#__PURE__*/function () {
  function EventBufferCompressionWorker(worker) {
    _classCallCheck(this, EventBufferCompressionWorker);

    ;

    EventBufferCompressionWorker.prototype.__init.call(this);

    EventBufferCompressionWorker.prototype.__init2.call(this);

    this._worker = worker;
  }

  _createClass(EventBufferCompressionWorker, [{
    key: "__init",
    value: function __init() {
      this._eventBufferItemLength = 0;
    }
  }, {
    key: "__init2",
    value: function __init2() {
      this._id = 0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Destroying compression worker');

      _optionalChain([this, 'access', function (_) {
        return _._worker;
      }, 'optionalAccess', function (_2) {
        return _2.terminate;
      }, 'call', function (_3) {
        return _3();
      }]);

      this._worker = null;
    }
    /**
     * Note that this may not reflect what is actually in the event buffer. This
     * is only a local count of the buffer size since `addEvent` is async.
     */

  }, {
    key: "length",
    get: function get() {
      return this._eventBufferItemLength;
    }
  }, {
    key: "addEvent",
    value: function () {
      var _addEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, isCheckout) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isCheckout) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this._postMessage({
                  id: this._getAndIncrementId(),
                  method: 'init',
                  args: []
                });

              case 3:
                return _context.abrupt("return", this._sendEventToWorker(event));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addEvent(_x, _x2) {
        return _addEvent.apply(this, arguments);
      }

      return addEvent;
    }()
  }, {
    key: "finish",
    value: function finish() {
      return this._finishRequest(this._getAndIncrementId());
    }
    /**
     * Post message to worker and wait for response before resolving promise.
     */

  }, {
    key: "_postMessage",
    value: function _postMessage(_ref2) {
      var _this2 = this;

      var id = _ref2.id,
          method = _ref2.method,
          args = _ref2.args;
      return new Promise(function (resolve, reject) {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        var listener = function listener(_ref3) {
          var data = _ref3.data;

          if (data.method !== method) {
            return;
          } // There can be multiple listeners for a single method, the id ensures
          // that the response matches the caller.


          if (data.id !== id) {
            return;
          } // At this point, we'll always want to remove listener regardless of result status


          _optionalChain([_this2, 'access', function (_4) {
            return _4._worker;
          }, 'optionalAccess', function (_5) {
            return _5.removeEventListener;
          }, 'call', function (_6) {
            return _6('message', listener);
          }]);

          if (!data.success) {
            // TODO: Do some error handling, not sure what
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('[Replay]', data.response);
            reject(new Error('Error in compression worker'));
            return;
          }

          resolve(data.response);
        };

        var stringifiedArgs;

        try {
          stringifiedArgs = JSON.stringify(args);
        } catch (err) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('[Replay] Error when trying to stringify args', err);
          stringifiedArgs = '[]';
        } // Note: we can't use `once` option because it's possible it needs to
        // listen to multiple messages


        _optionalChain([_this2, 'access', function (_7) {
          return _7._worker;
        }, 'optionalAccess', function (_8) {
          return _8.addEventListener;
        }, 'call', function (_9) {
          return _9('message', listener);
        }]);

        _optionalChain([_this2, 'access', function (_10) {
          return _10._worker;
        }, 'optionalAccess', function (_11) {
          return _11.postMessage;
        }, 'call', function (_12) {
          return _12({
            id: id,
            method: method,
            args: stringifiedArgs
          });
        }]);
      });
    }
  }, {
    key: "_sendEventToWorker",
    value: function _sendEventToWorker(event) {
      var promise = this._postMessage({
        id: this._getAndIncrementId(),
        method: 'addEvent',
        args: [event]
      }); // XXX: See note in `get length()`


      this._eventBufferItemLength++;
      return promise;
    }
  }, {
    key: "_finishRequest",
    value: function () {
      var _finishRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var promise;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                promise = this._postMessage({
                  id: id,
                  method: 'finish',
                  args: []
                }); // XXX: See note in `get length()`

                this._eventBufferItemLength = 0;
                return _context2.abrupt("return", promise);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _finishRequest(_x3) {
        return _finishRequest2.apply(this, arguments);
      }

      return _finishRequest;
    }()
  }, {
    key: "_getAndIncrementId",
    value: function _getAndIncrementId() {
      return this._id++;
    }
  }]);

  return EventBufferCompressionWorker;
}();

export { EventBufferCompressionWorker, createEventBuffer };